import { render, staticRenderFns } from "./AboCard.vue?vue&type=template&id=2e682abe&"
import script from "./AboCard.vue?vue&type=script&lang=ts&"
export * from "./AboCard.vue?vue&type=script&lang=ts&"
import style0 from "./AboCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports